// extracted by mini-css-extract-plugin
module.exports = {"search":"search_search__1Eavf","icon":"search_icon__3LBrz","input":"search_input__1dwGf","button":"search_button__17RBa"};